import { createApiCall } from 'lib/base';

const UPDATE_SUBSCRIPTION_INTEREST_REGISTRATION = 'UPDATE_SUBSCRIPTION_INTEREST_REGISTRATION';

const updateInterestRegistrationApi = createApiCall<{
  id: string;
  registrationId: string;
  payload: { notified_at: string | null };
}>(UPDATE_SUBSCRIPTION_INTEREST_REGISTRATION, ({ id, registrationId, payload }) => ({
  endpoint: `api/admin/subscriptions/${id}/interest-registrations/${registrationId}`,
  method: 'PATCH',
  body: payload,
}));

export default updateInterestRegistrationApi;
